import { useCallback, useEffect, useRef } from 'react';

function useScrollToTop<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  const scrollToTop = useCallback(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }, []);

  useEffect(scrollToTop, [scrollToTop]);

  return { ref, scrollToTop };
}

export { useScrollToTop };
